module.exports = __webpack_public_path__ + "static/media/icon_flag.d9a39182.png";